import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { FileDown, Printer, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Satın Alma Siparişi PDF — backend /purchase-orders/{id}/pdf (yetkili blob); yazdır (yeni sekme) + indir
export function PurchaseOrderPdfButtons({ po }) {
  const [busy, setBusy] = useState("");
  const fetchPdf = async (mode) => {
    setBusy(mode);
    try {
      const res = await api.get(`/purchase-orders/${po.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      if (mode === "download") {
        const a = document.createElement("a");
        a.href = url; a.download = `SatinAlma-${po.po_no || po.id}.pdf`; a.click();
      } else {
        const win = window.open(url, "_blank");
        if (win) win.addEventListener("load", () => setTimeout(() => win.print(), 400));
      }
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };
  const cls = "inline-flex items-center gap-1 text-[10px] font-mono uppercase border border-slate-700 rounded-sm px-1.5 py-0.5 hover:bg-slate-800 text-slate-200";
  return (
    <span className="inline-flex items-center gap-1" data-testid={`po-pdf-${po.id}`}>
      <span className="text-[11px] font-mono text-sky-300">{po.po_no}</span>
      <button type="button" className={cls} onClick={(e) => { e.stopPropagation(); fetchPdf("print"); }} disabled={!!busy}
        title="Satın Alma Siparişi PDF — Yazdır" data-testid={`po-pdf-print-${po.id}`}>
        {busy === "print" ? <Loader2 className="w-3 h-3 animate-spin" /> : <Printer className="w-3 h-3" />} PDF
      </button>
      <button type="button" className={cls} onClick={(e) => { e.stopPropagation(); fetchPdf("download"); }} disabled={!!busy}
        title="Satın Alma Siparişi PDF — İndir" data-testid={`po-pdf-download-${po.id}`}>
        {busy === "download" ? <Loader2 className="w-3 h-3 animate-spin" /> : <FileDown className="w-3 h-3" />}
      </button>
    </span>
  );
}
